import * as Yup from "yup";

export const paymantSchema = Yup.object().shape({
  description: Yup.string().required("Por favor, insira a descrição."),
  chart_account_id: Yup.mixed().test(
    "is-string",
    "Por favor, selecione um plano de conta",
    function (value) {
      if (!value) {
        return false;
      }

      if (typeof value === "object" && value.value) {
        return true;
      }
      return false;
    },
  ),
  terminate_days: Yup.number()
    .required("Por favor, insira os dias para baixa.")
    .positive("O número de dias deve ser positivo.")
    .integer("O número de dias deve ser um número inteiro.")
    .typeError("Por favor, insira um número válido."),
  tax: Yup.number()
    .required("Por favor, insira a taxa.")
    .min(0, "A taxa deve ser maior ou igual a zero.")
    .typeError("Por favor, insira um número válido."),
});